import { render, staticRenderFns } from "./propSelect.vue?vue&type=template&id=1acafbaf&"
import script from "./propSelect.vue?vue&type=script&lang=js&"
export * from "./propSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Projekte/woerner-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1acafbaf')) {
      api.createRecord('1acafbaf', component.options)
    } else {
      api.reload('1acafbaf', component.options)
    }
    module.hot.accept("./propSelect.vue?vue&type=template&id=1acafbaf&", function () {
      api.rerender('1acafbaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/woerner/propSelect.vue"
export default component.exports